"use client";

import CampaignInfo from "./more/CampaignInfo";
import CollectionButton from "./more/CollectionButton";
import SellerInfo from "./more/SellerInfo";
import ShareButton from "./more/ShareButton";

const ProductSidebar = () => {
  return (
    <div className="space-y-4">
      <ShareButton />
      <CampaignInfo />
      <SellerInfo />
      <CollectionButton />
    </div>
  );
};

export default ProductSidebar;
